module.exports = __webpack_public_path__ + "img/Preguntas.7f428b93.svg";